import { Component, computed, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { SessionHandoffActions } from 'src/app/features/session-handoff/store/actions';
import { selectAreAllParticipantsReady } from 'src/app/features/session-handoff/store/selectors/session-handoff.selectors';

/** Waiting room content for the new RON flow. Lifecycle stays in WaitingRoomComponent. */
@Component({
  selector: 'app-waiting-room-v2',
  templateUrl: './waiting-room-v2.component.html',
  styleUrls: ['./waiting-room-v2.component.scss'],
  standalone: false,
})
export class WaitingRoomV2Component implements OnInit {
  private readonly areAllParticipantsReady = this.store.selectSignal(selectAreAllParticipantsReady);

  readonly pageTitle = computed(() =>
    this.areAllParticipantsReady()
      ? 'Ready to join the notary session'
      : "You're almost ready for your notary session"
  );

  readonly cardTitle = computed(() =>
    this.areAllParticipantsReady()
      ? 'All participants have checked in'
      : 'Waiting for all participants'
  );

  readonly cardMessage = computed(() =>
    this.areAllParticipantsReady()
      ? "Your notary has been notified and will join shortly. You'll be connected when the session begins — no action needed."
      : 'Once everyone has joined the waiting room, your notary session will begin ' +
        'automatically. If other signers will be joining you on this device, confirm ' +
        'their identity below. Your notary will join once everyone has checked in.'
  );

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(SessionHandoffActions.ActivateSessionHandoff());
  }

  onParticipantJoined(packageUserGuid: string): void {
    // isWaitingRoom drives the viewed dispatch from joinSessionSuccess$, after PIN/MFA resolves.
    this.store.dispatch(
      SessionHandoffActions.JoinSession({ payload: { packageUserGuid, isWaitingRoom: true } })
    );
  }
}
